import {configuracionService} from "@/api/coreApi"

const state = {
  loading: true,
  menus: null,
  error: null
};

const actions = {
  getMenus({commit}) {
    return new Promise((resolve, reject) => {
      commit('menusInit')

      configuracionService.getMenus()
        .then(response => {
          if (response.data.statusCode === 200) {
            commit('menusSuccess', response.data)
            resolve()
          } else {
            commit('menusFailure', response)
            reject()
          }

        })
        .catch(error => {
          commit('menusFailure', error)
          reject()
        });
    })
  },
};

const mutations = {
  menusInit(mstate) {
    mstate.loading = true
  },
  menusSuccess(mstate, data) {
    mstate.loading = false
    mstate.menus = JSON.parse(data.datos)
  },
  menusFailure(mstate, error) {
    mstate.error = error
  }
};

export const menus = {
  namespaced: true,
  state: state,
  actions: actions,
  mutations: mutations
};
